import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'fi';
    document.title = 'LIIKUNTA VALMIS™ – Valmiit liikuntatunnit 1.–9. luokille';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mk84asujy1aw">
      <div lang="fi" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mj6lg27aoaim">
        <CountdownBar data-id="element-2" data-mp="3reltuemj9e7n" />
        <main data-id="element-3" data-mp="5orh0l86u6j">
          <Hero data-id="element-4" data-mp="67yhm9c7y5s" />
          <StatsBar data-id="element-5" data-mp="4n4pyuukj8z" />
          <Difference data-id="element-6" data-mp="56lvdcob3ly" />
          <Recognize data-id="element-7" data-mp="7sxpp6lk59z" />
          <WhatsInside data-id="element-8" data-mp="2zllen0i82im7" />
          <InsidePages data-id="element-9" data-mp="2zm4vedw4z0yn" />
          <Bonuses data-id="element-10" data-mp="2zmwggus3xgao" />
          <HowItWorks data-id="element-11" data-mp="2zng1wlgyumtg" />
          <Audience data-id="element-12" data-mp="33m5am0r27g6r" />
          <Offer data-id="element-13" data-mp="33nq4do5juv3k" />
          <Guarantee data-id="element-14" data-mp="33n6xr3lcnt4u" />
          <Testimonials data-id="element-15" data-mp="33orkw85c49so" />
          <Faq data-id="element-16" data-mp="38m1fe27kzbnd" />
          <FinalCta data-id="element-17" data-mp="38li7zffk45nl" />
        </main>
        <Footer data-id="element-18" data-mp="38kgkucl9nspi" />
      </div>
    </MotionConfig>;
}